import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './phone-verification.magic.css.js';
import script from './phone-verification.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phone-verification"},[_c('div',{staticClass:"phone-verification__content"},[_c('p',{staticClass:"phone-verification__description"},[_vm._v("\n            "+_vm._s(_vm.$t('phone-verification.description'))+"\n        ")]),_vm._v(" "),_c('form',{staticClass:"phone-verification__form"},[(_vm.hasCodeBeenSent)?_c('magic-ui-form-field',{staticClass:"phone-verification__code-field",attrs:{"has-error":_vm.invalidCode,"message":_vm.$t('phone-verification.error'),"placeholder":_vm.$t('phone-verification.code-placeholder')}},[_c('magic-ui-input',{ref:"codeInput",staticClass:"code-input",attrs:{"type":"tel","value":_vm.code},on:{"input":_vm.handleInput,"keyup":_vm.resetError}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"phone-verification__actions"},[_c('magic-ui-button',{staticClass:"phone-verification__action-button",attrs:{"wide":"","variant":"primary","hollow":_vm.hasCodeBeenSent,"disabled":_vm.isLoading || _vm.resendDisabled,"loading":_vm.isLoading && !_vm.hasCodeBeenSent},on:{"click":function($event){$event.preventDefault();return _vm.sendVerificationCode($event)}}},[_vm._v("\n                    "+_vm._s(!_vm.hasCodeBeenSent 
                        ? _vm.$t('phone-verification.send-code') 
                        : _vm.resendDisabled 
                            ? _vm.$t('phone-verification.resend-code') + " (" + _vm.resendCooldownSeconds + "s)"
                            : _vm.$t('phone-verification.resend-code'))+"\n                ")]),_vm._v(" "),(_vm.hasCodeBeenSent)?_c('magic-ui-button',{staticClass:"phone-verification__action-button phone-verification__submit-button",attrs:{"wide":"","variant":"primary","disabled":_vm.isLoading || !_vm.isCodeValid,"loading":_vm.isLoading && _vm.hasCodeBeenSent},on:{"click":function($event){$event.preventDefault();return _vm.verifyPhoneCode($event)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('phone-verification.submit'))+"\n                ")]):_vm._e()],1)],1)])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-35c72912_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-35c72912";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
